<app-link
    [link]="link"
    [cover]="cover"
    [queryParams]="queryParams"
    (click)="linkClick.emit()"
    styleClass="kk-link kk-arrow-link"
>
    <div class="content">
        <div class="arrow" [ngClass]="'kk-float-horizontally-' + direction" *ngIf="arrowFirst">
            <app-svg-icon [iconName]="'arrow_' + direction"></app-svg-icon>
        </div>
        <span class="kk-overflow-ellipsis">
            <ng-content></ng-content>
        </span>
        <div class="arrow" [ngClass]="'kk-float-horizontally-' + direction" *ngIf="!arrowFirst">
            <app-svg-icon [iconName]="'arrow_' + direction"></app-svg-icon>
        </div>
    </div>
</app-link>
